import assign = require('object-assign');
import * as moment from 'moment';

import IReportSettings from '../interfaces/IReportSettings';
import { IReportSettingAction } from '../interfaces/actions';

import { ReportSetting, Customer } from '../constants'

const initialState: IReportSettings = {
    customerId: '',
    startMs : moment().startOf('month').add(-1, 'months').valueOf(),
    endMs : moment().startOf('month').valueOf(),
};

export default function SaveState(state: IReportSettings = initialState, action: IReportSettingAction): IReportSettings {
    switch (action.type) {
        case Customer.FETCH_CUSTOMERS_SUCCESS: {
            if(!state.customerId && action.payload && action.payload.length) {
                return assign({}, state, {
                    customerId: action.payload[0].cId,
                    startMs: initialState.startMs,
                    endMs: initialState.endMs,
                });
            }
        }
        case ReportSetting.SET: {
            return assign({}, state, {
                [action.key]: action.value
            });
        }
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./src/reducers/reportSettings.ts